import { render, staticRenderFns } from "./projectAdd.vue?vue&type=template&id=54afd244&scoped=true"
import script from "./projectAdd.vue?vue&type=script&lang=js"
export * from "./projectAdd.vue?vue&type=script&lang=js"
import style0 from "./projectAdd.vue?vue&type=style&index=0&id=54afd244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afd244",
  null
  
)

export default component.exports